<template>
    <div class="position-box IEO">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('ieo.gmjl')}}</div>
        </div>
        <div class="cotainer help">
          <ul class="ul-box">
            <li class="ul-li" v-for="(item, index) in list" :key="index">
              <div class="title">
                <div>{{item.currency}}/USDT-{{$t('ieo.sjd')}}</div>
                <!-- <div class="t2 active" v-if="item.status == 0">{{$t('xbsg.shz')}}</div>
                <div class="t2" v-else-if="item.status == 1">{{$t('xbsg.ytg')}}</div>
                <div class="t2" v-else>{{$t('xbsg.wtg')}}</div> -->
              </div>
              <div class="item-box">
                <div class="item-lt">
                  <div class="item">
                    <div class="t1">{{$t('jghy.sl')}}</div>
                    <div class="t2">{{item.amount}}</div>
                    <div class="t1">{{$t('jghy.yk')}}</div>
                    <div class="t2 money">{{item.profit_loss}}</div>
                    <!-- <div class="t1">{{$t('xbsg.ssrq')}}</div> -->
                  </div>
                </div>
                <div class="item-rt">
                  <div class="item">
                    <div class="t1">{{$t('bbjy.jg')}}</div>
                    <div class="t2">{{item.price}}</div>
                    <div class="t1">{{$t('kxt.sj')}}</div>
                    <div class="t2">{{item.time}}</div>
                     <!-- <div class="t2">{{item.start_time_format}}</div> -->
                  </div>
                </div>
              </div>
            </li>
            <!-- <li class="ul-li">
              <div class="title">ZFB/USDT-市价单</div>
              <div class="item-box">
                <div class="item-lt">
                  <div class="item">
                    <div class="t1">数量</div>
                    <div class="t2">101252235.0000</div>
                    <div class="t1">盈亏</div>
                    <div class="t2 money">+$35532210.0000</div>
                  </div>
                </div>
                <div class="item-rt">
                  <div class="item">
                    <div class="t1">价格</div>
                    <div class="t2">202.20</div>
                    <div class="t1">时间</div>
                    <div class="t2">2024-12-6</div>
                  </div>
                </div>
              </div>
            </li> -->
          </ul>
          <!-- 暂无数据 -->
          <div class="null-box" v-show="isNoData">
            <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
            <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
            <p class="text">{{$t('zwsj.title')}}</p>
          </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'IEORecords',
    data () {
        return {
          theme: false,
          isNoData: false,
          theme: false,
          list: [],
          icon: '',
          currency: '',
          timer2: null,
          isGoTOP: false,
          curDataLength: 10,
          page: 1,
          lang: 'en'
        }
    },
    beforeCreate(){
      that = this;
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
      this.currency = this.$route.query.currency;
    },
    mounted() {
      this.getWeiTuo();
      this.timer2 = setInterval(()=>{
        this.getWeiTuo();
      },5000)
    },
    methods: {
      back(){
        this.$router.push('/IEOPurchase')
      },
       getWeiTuo(){
        let that = this;
        let params = {
          currency: this.currency,
          page: that.page,
          mark: 1,
          type: 1,
          wt: 12,
        }
        this.$ajax.get('/web/getWeiTuo',{params}).then((res) => {
            if(res.data.code == 1000){
              this.$router.push('/login')
            }else{
              let resData = res.data.data.list;
              if(resData.length > 0){
                this.list = resData;
                this.curDataLength = resData.length;
              }else{
                this.curDataLength = resData.length;
              }
              if(this.list.length > 0){
                  this.isNoData = false;
              }else{
                  this.isNoData = true;
              }
            }

        }).catch(function(err){
            console.log(err)
        })
      },
      getMyNewcoins(){
        let params = {
          page: this.page
        }
        this.$ajax.get('/web/getMyNewcoins',{params}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              // this.$toast.center(res.data.message);
              setTimeout(()=>{
                this.$router.push('/login');
              },1000)
              return false
            }
            if(resData.length > 0){
              this.list = resData;
              this.curDataLength = resData.length;
            }else{
                this.curDataLength = resData.length;
            }
            if(this.list.length > 0){
                this.isNoData = false;
            }else{
                this.isNoData = true;
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      listenScroll(e) {  //监听滚动
        let ele = e.srcElement ? e.srcElement : e.target;
        if(ele.scrollTop > 200){
            this.isGoTOP = true
        }else{
            this.isGoTOP = false
        }
        if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
          if(this.curDataLength > 0){
            this.page ++;
            this.getWeiTuo();
          }
        }
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      }
    },
    components:{
        navBar,
    },
    beforeDestroy(){
      clearInterval(this.timer2);
      this.timer2 = null;
    },
    destroyed(){
      clearInterval(this.timer2);
      this.timer2 = null;
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .ul-box{
      margin: .38rem;
    }
    .cotainer .ul-box .ul-li{
      margin-bottom: .38rem;
      padding: .48rem .5rem .5rem .38rem;
      background: #fff;
      border-radius: 0.25rem;
      box-shadow: 0 0 0.38rem 0.19rem rgba(6, 0, 1, 0.15);
    }
    .cotainer .ul-box .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: .1rem;
      color: #000;
      font-size: .4rem;
    }
    .cotainer .ul-box .title .t2.active{
      color: #588bf8;
    }
    .cotainer .ul-box .item-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: transparent !important;
    }
    .cotainer .ul-box .t1{
      padding-top: .3rem;
      color: #8a8a8a;
      font-size: .34rem;
    }
    .cotainer .ul-box .t2{
      padding-top: .3rem;
      color: #000;
      font-size: .34rem;
    }
    .cotainer .ul-box .t2.money{
      color: #eee;
    }
    .cotainer .ul-box .item-rt{
      text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/pages/IEORecords.vue